import { usePrograms } from "@/modules/programs/hooks/usePrograms"
import { ProgramFilter } from "@/modules/programs/types/programTypes"
import { useTrainingProgramFilterActions } from "@/modules/training/stores/useTrainingProgramFilterStore"
import { CalendarProvider } from "@modules/calendar/context/calendarContext"
import { usePlanningSessionEvents } from "@modules/training/hooks/useTraining"
import dayjs from "dayjs"
import { useCallback, useEffect, useState } from "react"
import { TrainingContent } from "@/modules/training/components/trainingContent"

export function TrainingPage() {
  const [calendarRange, setCalendarRange] = useState<{ startDate: string; endDate: string }>()
  const { refetch } = usePlanningSessionEvents(calendarRange?.startDate, calendarRange?.endDate)
  const {
    data: { content: programs },
  } = usePrograms({
    programFilter: ProgramFilter.ALL,
    size: 1000,
    sort: "SUBSCRIPTION_DATE",
    page: 0,
  })
  const { initSelectedPrograms } = useTrainingProgramFilterActions()

  useEffect(() => {
    initSelectedPrograms(programs)
  }, [])

  const onDateSet = useCallback(
    ({
      startDate,
      endDate,
    }: { startDate: dayjs.Dayjs; endDate: dayjs.Dayjs } | { startDate: number; endDate: number }) => {
      setCalendarRange({ startDate: startDate.toString(), endDate: endDate.toString() })
    },
    [],
  )

  const refreshEvents = () => {
    refetch()
  }

  return (
    <CalendarProvider
      initialDate={dayjs().startOf("day")}
      onDateSet={onDateSet}
      defaultDisplayDetailedEvents={false}
      defaultView="dayGridWeek"
      refreshEvents={refreshEvents}
    >
      <TrainingContent calendarRange={calendarRange} />
    </CalendarProvider>
  )
}
